import { render, staticRenderFns } from "./RemoveManagerContractorRequest.vue?vue&type=template&id=23ce70dc&scoped=true"
import script from "./RemoveManagerContractorRequest.vue?vue&type=script&lang=ts"
export * from "./RemoveManagerContractorRequest.vue?vue&type=script&lang=ts"
import style0 from "./RemoveManagerContractorRequest.vue?vue&type=style&index=0&id=23ce70dc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ce70dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23ce70dc')) {
      api.createRecord('23ce70dc', component.options)
    } else {
      api.reload('23ce70dc', component.options)
    }
    module.hot.accept("./RemoveManagerContractorRequest.vue?vue&type=template&id=23ce70dc&scoped=true", function () {
      api.rerender('23ce70dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/RemoveManagerContractorRequest.vue"
export default component.exports